export default __webpack_public_path__ + "static/media/Image 97@2x.a65b56e9.png";